const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  userId: state => state.user.userId,
  name: state => state.user.name,
  orgId: state => state.user.orgId,
  orgName: state => state.user.orgName,
  orgCategory: state => state.user.orgCategory,
  expiredStatus: state => state.user.expiredStatus,
  memberValidDate: state => state.user.memberValidDate,
  routesLists: state => state.user.routesList,
  imageCache: state => state.app.imageCache,
  themeType: state => state.theme.type,
  createOrderRole:state => state.user.createOrderRole,
  userLevel:state => state.user.userLevel,
  menuCodes:state => state.user.menuCodes,
  roleCode:state => state.user.roleCode,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js